"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateComponents = exports.TemplateModels = void 0;
const building_block_type_1 = require("./building-block-type");
const custom_1 = require("./custom");
const template_type_1 = require("./template-type");
const templates_1 = require("./templates");
exports.TemplateModels = [
    templates_1.TemplateModel,
    custom_1.CustomTemplateModel,
];
exports.TemplateComponents = [
    template_type_1.TemplateTypeTranslation,
    building_block_type_1.BuildingBlockTypeTranslation,
];
